var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { SiteHeaderContext, SiteHeaderDefaultState } from "../context/site-header-context";
import * as React from 'react';
import { includes, map } from "lodash";
import { classNames } from "@shapeable/utils";
import { useInView } from "react-intersection-observer";
var cls = classNames('site-header-layout');
import { trim, size } from 'lodash';
import { PersonIcon, useIcons } from "@shapeable/icons";
import { useSite } from "./use-site";
import { useMainMenu } from "./use-main-menu";
import { useActiveEntity } from "./use-active-entity";
import { useEnv } from "./use-env";
import { useSiteMenuBar } from "./use-site-menu-bar";
import { useAuth } from "./use-auth";
import { useCookieLevel } from "./use-cookie-level";
import { useSocialLinks } from "./use-social-links";
import { usePatchableState } from "./use-patchable-state";
import { useClickOutside } from "./use-click-outside";
export var useSiteHeader = function () {
  var e_1, _a;
  var _b, _c, _d, _e, _f, _g;
  var site = useSite();
  var menu = useMainMenu();
  var currentEntity = useActiveEntity();
  var Icons = useIcons();
  var env = useEnv();
  var menuBar = useSiteMenuBar();
  var loginLabel = site.loginLabel,
    platformLoginLabel = site.platformLoginLabel,
    platformUrl = site.platformUrl;
  var icons = useIcons();
  var auth = useAuth();
  var _h = __read(useCookieLevel(), 2),
    cookies = _h[0],
    setCookies = _h[1];
  var socialLinks = useSocialLinks();
  var socialCount = size(socialLinks);
  var context = React.useContext(SiteHeaderContext);
  var defaultState = __assign(__assign({}, SiteHeaderDefaultState), context.defaultState || {});
  var _j = context.variant,
    variant = _j === void 0 ? 'overlay' : _j,
    showActiveBar = context.showActiveBar;
  var menuItemIsAvailable = context.menuItemIsAvailable || function () {
    return true;
  };
  var showLogin = auth.isAvailable && (context.showLogin || site.showLogin || env.SHOW_LOGIN);
  var showThemeMode = context.showThemeMode; // || env.SHOw_THEME;
  var showPlatformLogin = context.showPlatformLogin || site.showPlatformLogin || env.SHOW_PLATFORM_LOGIN;
  var showShare = context.showShare || site.showShareMenu || env.SHOW_SHARE;
  var showFollow = socialCount > 0 && (context.showFollow || site.showFollowMenu || env.SHOW_FOLLOW);
  var showContactUs = context.showContactUs || site.showContactUs || env.SHOW_CONTACT_US;
  var showLinearNavigation = context.showLinearNavigation || env.SHOW_LINEAR_NAVIGATION;
  var showUtilities = context.showUtilities; // This needs to be added to site and env
  // NEW: we now disable the login functionaility until user agrees to cookies
  var showUser = showLogin || showPlatformLogin;
  var userLabel = ((_b = auth.user) === null || _b === void 0 ? void 0 : _b.givenName) || site.loginButtonLabel;
  var tuple = React.useState(defaultState);
  var _k = __read(usePatchableState(tuple), 3),
    state = _k[0],
    setState = _k[1],
    patchState = _k[2];
  var isLangMenuVisible = state.isLangMenuVisible,
    isShareMenuVisible = state.isShareMenuVisible,
    isFollowMenuVisible = state.isFollowMenuVisible,
    isNavigationMenuVisible = state.isNavigationMenuVisible,
    isPinnedNavigationMenuVisible = state.isPinnedNavigationMenuVisible,
    isContactUsMenuVisible = state.isContactUsMenuVisible,
    isUserMenuVisible = state.isUserMenuVisible,
    disclosedMenuItem = state.disclosedMenuItem,
    isMenuBarVisible = state.isMenuBarVisible,
    isUtilityMenuVisible = state.isUtilityMenuVisible,
    isThemeModeMenuVisible = state.isThemeModeMenuVisible;
  var hideFollowMenu = function () {
    return patchState({
      isFollowMenuVisible: false
    });
  };
  var hideThemeModeMenu = function () {
    return patchState({
      isThemeModeMenuVisible: false
    });
  };
  var hideLangMenu = function () {
    return patchState({
      isLangMenuVisible: false
    });
  };
  var hideUtilityMenu = function () {
    return patchState({
      isUtilityMenuVisible: false
    });
  };
  var hideShareMenu = function () {
    return patchState({
      isShareMenuVisible: false
    });
  };
  var hideNavigationMenu = function () {
    return patchState({
      isNavigationMenuVisible: false
    });
  };
  var hidePinnedNavigationMenu = function () {
    return patchState({
      isPinnedNavigationMenuVisible: false
    });
  };
  var hideContactUsMenu = function () {
    return patchState({
      isContactUsMenuVisible: false
    });
  };
  var hideUserMenu = function () {
    return patchState({
      isUserMenuVisible: false
    });
  };
  var setDisclosedMenuItem = function (disclosedMenuItem) {
    return patchState({
      disclosedMenuItem: disclosedMenuItem
    });
  };
  var hideDisclosedMenuItem = function () {
    return patchState({
      disclosedMenuItem: ''
    });
  };
  var showFollowMenu = function () {
    return patchState({
      isFollowMenuVisible: true,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showThemeModeMenu = function () {
    return patchState({
      isThemeModeMenuVisible: true,
      isFollowMenuVisible: false,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showUtilityMenu = function () {
    return patchState({
      isUtilityMenuVisible: true,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isFollowMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showUserMenu = function () {
    return patchState({
      isUserMenuVisible: true,
      isFollowMenuVisible: false,
      isLangMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showLangMenu = function () {
    return patchState({
      isLangMenuVisible: true,
      isUserMenuVisible: false,
      isFollowMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showShareMenu = function () {
    return patchState({
      isShareMenuVisible: true,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isFollowMenuVisible: false,
      isUtilityMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showNavigationMenu = function () {
    return patchState({
      isNavigationMenuVisible: true,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isFollowMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isPinnedNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showPinnedNavigationMenu = function () {
    return patchState({
      isPinnedNavigationMenuVisible: true,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isFollowMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isContactUsMenuVisible: false
    });
  };
  var showContactUsMenu = function () {
    return patchState({
      isContactUsMenuVisible: true,
      isUserMenuVisible: false,
      isLangMenuVisible: false,
      isFollowMenuVisible: false,
      isUtilityMenuVisible: false,
      isShareMenuVisible: false,
      isNavigationMenuVisible: false,
      isPinnedNavigationMenuVisible: false
    });
  };
  var toggleLangMenu = function () {
    if (isLangMenuVisible) {
      hideLangMenu();
    } else {
      showLangMenu();
    }
  };
  var toggleThemeModeMenu = function () {
    if (isThemeModeMenuVisible) {
      hideThemeModeMenu();
    } else {
      showThemeModeMenu();
    }
  };
  var toggleUtilityMenu = function () {
    if (isUtilityMenuVisible) {
      hideUtilityMenu();
    } else {
      showUtilityMenu();
    }
  };
  var toggleUserMenu = function () {
    if (isUserMenuVisible) {
      hideUserMenu();
    } else {
      showUserMenu();
    }
  };
  var toggleShareMenu = function () {
    if (isShareMenuVisible) {
      hideShareMenu();
    } else {
      showShareMenu();
    }
  };
  var toggleFollowMenu = function () {
    if (isFollowMenuVisible) {
      hideFollowMenu();
    } else {
      showFollowMenu();
    }
  };
  var toggleNavigationMenu = function () {
    if (isNavigationMenuVisible) {
      hideNavigationMenu();
    } else {
      showNavigationMenu();
    }
  };
  var togglePinnedNavigationMenu = function () {
    if (isPinnedNavigationMenuVisible) {
      hidePinnedNavigationMenu();
    } else {
      showPinnedNavigationMenu();
    }
  };
  var toggleContactUsMenu = function () {
    if (isContactUsMenuVisible) {
      hideContactUsMenu();
    } else {
      showContactUsMenu();
    }
  };
  var langMenuRef = useClickOutside(function (e) {
    if (isLangMenuVisible) {
      hideLangMenu();
    }
  }, [isLangMenuVisible]);
  var langMenuRevealRef = useClickOutside(function (e) {
    if (isLangMenuVisible) {
      hideLangMenu();
    }
  }, [isLangMenuVisible]);
  var themeModeMenuRef = useClickOutside(function (e) {
    if (isThemeModeMenuVisible) {
      hideThemeModeMenu();
    }
  }, [isThemeModeMenuVisible]);
  var themeModeMenuRevealRef = useClickOutside(function (e) {
    if (isThemeModeMenuVisible) {
      hideThemeModeMenu();
    }
  }, [isThemeModeMenuVisible]);
  var shareMenuRevealRef = useClickOutside(function (e) {
    if (isShareMenuVisible) {
      hideShareMenu();
    }
  }, [isShareMenuVisible]);
  var shareMenuRef = useClickOutside(function (e) {
    if (isShareMenuVisible) {
      hideShareMenu();
    }
  }, [isShareMenuVisible]);
  var utilityMenuRef = useClickOutside(function (e) {
    if (isUtilityMenuVisible) {
      hideUtilityMenu();
    }
  }, [isUtilityMenuVisible]);
  var utilityMenuRevealRef = useClickOutside(function (e) {
    if (isUtilityMenuVisible) {
      hideUtilityMenu();
    }
  }, [isUtilityMenuVisible]);
  var followMenuRevealRef = useClickOutside(function (e) {
    if (isFollowMenuVisible) {
      hideFollowMenu();
    }
  }, [isFollowMenuVisible]);
  var followMenuRef = useClickOutside(function (e) {
    if (isFollowMenuVisible) {
      hideFollowMenu();
    }
  }, [isFollowMenuVisible]);
  var userMenuRef = useClickOutside(function (e) {
    if (isUserMenuVisible) {
      hideUserMenu();
    }
  }, [isUserMenuVisible]);
  var userMenuRevealRef = useClickOutside(function (e) {
    if (isUserMenuVisible) {
      hideUserMenu();
    }
  }, [isUserMenuVisible]);
  var pinnedNavigationMenuRef = useClickOutside(function (e) {
    if (isPinnedNavigationMenuVisible) {
      hidePinnedNavigationMenu();
    }
  }, [isPinnedNavigationMenuVisible]);
  var navigationMenuRef = useClickOutside(function (e) {
    if (isNavigationMenuVisible) {
      hideNavigationMenu();
    }
  }, [isNavigationMenuVisible]);
  var navigationDisclosedItemRef = useClickOutside(function (e) {
    if (disclosedMenuItem) {
      hideDisclosedMenuItem();
    }
  }, [disclosedMenuItem]);
  var _l = useInView({
      delay: menuBar.delay
    }),
    inViewRef = _l.ref,
    inView = _l.inView;
  React.useEffect(function () {
    var scrollY = 0;
    if (typeof window !== 'undefined') {
      scrollY = window.scrollY;
    }
    patchState({
      isMenuBarVisible: !inView && scrollY > 0
    });
  }, [inView]);
  var PLATFORM_LOGIN_ITEM = {
    id: 'platform-login',
    name: loginLabel,
    url: platformUrl,
    children: [],
    isDisclosed: false,
    __icon: React.createElement(PersonIcon, null),
    __iconSize: 32,
    isActive: false
  };
  // TODO - make this recursive
  var pinnedNavigationMenuItems = map(__spreadArray([], __read(menu && menu.items || []), false), function (item) {
    var _a;
    var hasChildren = item.children && !!item.children.length;
    var isActive = hasChildren ? includes((_a = item.children) === null || _a === void 0 ? void 0 : _a.map(function (item) {
      return item.path;
    }), currentEntity && currentEntity.path) : trim(item.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(item.path, '/');
    return __assign(__assign({}, item), {
      isDisclosed: disclosedMenuItem === item.id,
      hasChildren: hasChildren,
      children: map(item.children, function (child) {
        return __assign(__assign({}, child), {
          isDisclosed: false,
          children: [],
          hasChildren: false,
          isActive: trim(child.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(child.path, '/')
        });
      }),
      isActive: isActive
    });
  });
  var navigationMenuItems = __spreadArray([], __read(pinnedNavigationMenuItems), false);
  var _m = site.headerButtons,
    headerButtons = _m === void 0 ? [] : _m;
  var _loop_1 = function (link) {
    /* @ts-ignore */
    var Icon = icons[(_c = link.icon) === null || _c === void 0 ? void 0 : _c.component];
    var href = link.url || ((_d = link.page) === null || _d === void 0 ? void 0 : _d.path);
    navigationMenuItems.push({
      id: link.id,
      onClick: !href && context.onHeaderButtonClick && function () {
        context.onHeaderButtonClick(link.slug);
        hideNavigationMenu();
      },
      name: link.label || ((_e = link.page) === null || _e === void 0 ? void 0 : _e.title) || ((_f = link.page) === null || _f === void 0 ? void 0 : _f.name) || link.name,
      url: link.url || ((_g = link.page) === null || _g === void 0 ? void 0 : _g.path),
      isDisclosed: false,
      page: link.page,
      __icon: Icon && React.createElement(Icon, null),
      // TODO make these work
      isActive: trim(link.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(link.path, '/'),
      hasChildren: false,
      children: []
    });
  };
  try {
    for (var headerButtons_1 = __values(headerButtons), headerButtons_1_1 = headerButtons_1.next(); !headerButtons_1_1.done; headerButtons_1_1 = headerButtons_1.next()) {
      var link = headerButtons_1_1.value;
      _loop_1(link);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (headerButtons_1_1 && !headerButtons_1_1.done && (_a = headerButtons_1.return)) _a.call(headerButtons_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return __assign(__assign({}, context), {
    variant: variant,
    showActiveBar: showActiveBar === undefined ? variant === 'overlay' : false,
    onHeaderButtonClick: context.onHeaderButtonClick || function () {},
    barHeight: context.barHeight || 2,
    showLogin: showLogin,
    showThemeMode: showThemeMode,
    showPlatformLogin: showPlatformLogin,
    showShare: showShare,
    showFollow: showFollow,
    showUtilities: showUtilities,
    showUser: showUser,
    showContactUs: showContactUs,
    showLinearNavigation: showLinearNavigation,
    disclosedMenuItem: disclosedMenuItem,
    isUtilityMenuVisible: isUtilityMenuVisible,
    isThemeModeMenuVisible: isThemeModeMenuVisible,
    isFollowMenuVisible: isFollowMenuVisible,
    isLangMenuVisible: isLangMenuVisible,
    isShareMenuVisible: isShareMenuVisible,
    isNavigationMenuVisible: isNavigationMenuVisible,
    isPinnedNavigationMenuVisible: isPinnedNavigationMenuVisible,
    isContactUsMenuVisible: isContactUsMenuVisible,
    isUserMenuVisible: isUserMenuVisible,
    isMenuBarVisible: isMenuBarVisible,
    inViewRef: inViewRef,
    // reveal refs are for the mobile breakpoint menus
    langMenuRef: langMenuRef,
    langMenuRevealRef: langMenuRevealRef,
    themeModeMenuRef: themeModeMenuRef,
    themeModeMenuRevealRef: themeModeMenuRevealRef,
    shareMenuRef: shareMenuRef,
    shareMenuRevealRef: shareMenuRevealRef,
    userMenuRef: userMenuRef,
    userMenuRevealRef: userMenuRevealRef,
    followMenuRef: followMenuRef,
    followMenuRevealRef: followMenuRevealRef,
    utilityMenuRef: utilityMenuRef,
    utilityMenuRevealRef: utilityMenuRevealRef,
    navigationMenuRef: navigationMenuRef,
    pinnedNavigationMenuRef: pinnedNavigationMenuRef,
    navigationDisclosedItemRef: navigationDisclosedItemRef,
    onFollowButtonClick: function (e) {
      e.stopPropagation();
      toggleFollowMenu();
    },
    onThemeModeButtonClick: function (e) {
      e.stopPropagation();
      toggleThemeModeMenu();
    },
    onShareButtonClick: function (e) {
      e.stopPropagation();
      toggleShareMenu();
    },
    onLangButtonClick: function (e) {
      e.stopPropagation();
      toggleLangMenu();
    },
    onMenuButtonClick: function (e) {
      e.stopPropagation();
      toggleNavigationMenu();
    },
    onPinnedMenuButtonClick: function (e) {
      e.stopPropagation();
      togglePinnedNavigationMenu();
    },
    onContactUsButtonClick: function (e) {
      e.stopPropagation();
      toggleContactUsMenu();
    },
    onUserButtonClick: function (e) {
      e.stopPropagation();
      if (cookies === 'accept' || cookies === 'accept-functional') {
        toggleUserMenu();
      }
    },
    onUtilityMenuButtonClick: function (e) {
      e.stopPropagation();
      toggleUtilityMenu();
    },
    navigationMenuItems: navigationMenuItems,
    pinnedNavigationMenuItems: pinnedNavigationMenuItems,
    loginLabel: loginLabel,
    platformLoginLabel: platformLoginLabel,
    menuItemIsAvailable: menuItemIsAvailable,
    toggleLangMenu: toggleLangMenu,
    toggleThemeModeMenu: toggleThemeModeMenu,
    toggleFollowMenu: toggleFollowMenu,
    toggleShareMenu: toggleShareMenu,
    toggleNavigationMenu: toggleNavigationMenu,
    togglePinnedNavigationMenu: togglePinnedNavigationMenu,
    toggleContactUsMenu: toggleContactUsMenu,
    toggleUserMenu: toggleUserMenu,
    toggleUtilityMenu: toggleUtilityMenu,
    setDisclosedMenuItem: setDisclosedMenuItem,
    hideDisclosedMenuItem: hideDisclosedMenuItem,
    hideLangMenu: hideLangMenu,
    hideThemeModeMenu: hideThemeModeMenu,
    hideShareMenu: hideShareMenu,
    hideFollowMenu: hideFollowMenu,
    hideNavigationMenu: hideNavigationMenu,
    hidePinnedNavigationMenu: hidePinnedNavigationMenu,
    hideContactUsMenu: hideContactUsMenu,
    hideUserMenu: hideUserMenu,
    hideUtilityMenu: hideUtilityMenu,
    showLangMenu: showLangMenu,
    showThemeModeMenu: showThemeModeMenu,
    showShareMenu: showShareMenu,
    showFollowMenu: showFollowMenu,
    showNavigationMenu: showNavigationMenu,
    showPinnedNavigationMenu: showPinnedNavigationMenu,
    showContactUsMenu: showContactUsMenu,
    showUserMenu: showUserMenu,
    showUtilityMenu: showUtilityMenu,
    userLabel: userLabel,
    isDisclosedMenuItem: function (item) {
      var _a;
      return !!((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length) && disclosedMenuItem === (item === null || item === void 0 ? void 0 : item.id);
    }
  });
};